<template>
  <div class="page-wrapper dir-ltr">
    <!-- <div class="half-page-wrapper"> -->
    <div class="step" v-if="step <= 4">
      <div v-if="step === 1">
        <div class="my-2 welcome-title">Welcome to the YazamTech CDR Filtering System</div>
        <div class="welcome-content">

<ul>
  <li>
    <p>asdf</p>
    <ul>
      <li>
        asd
      </li>
      <li>
        asd
      </li>
      <li>
        asd
      </li>
      <li>
        asd
      </li>
    </ul>
  </li>
  <li>
    asdf
  </li>
  <li>
    asdf
  </li>
  <li>
    asdf
  </li>
  <li>
    asdf
  </li>
</ul>

          <p class="my-2">
            Send a file for filtering according to the selected policy.
          </p>
          <div class="d-flex align-center my-2">
            <p>You can select a file from your local device or</p>
            <Button text="use a sample file" class="mx-1" />
          </div>
          <p class="my-2">Supported file types: {{ computedPolicies }}.</p>
          <p class="my-2">Maximum file size: {{ computedSizeLimit }}.</p>
        </div>
      </div>
      <div v-if="step === 2">
        <div
          v-if="getSessionData?.filesData?.length"
          class="files-list-wrapper"
        >
          <SelectedFilesList :session="getSessionData" />
          <span>Total size: {{ getSessionData?.totalSize | bytesToSize }}</span>
          <div>
            <Button
              v-if="getSessionData?.filesData?.length"
              text="Choose another file"
              :clickAction="chooseFilesClicked"
              class="mt-4"
            />
          </div>
        </div>
        <div v-else>
          <Button
            text="Choose File"
            v-if="step != 1"
            :clickAction="chooseFilesClicked"
          />
        </div>
      </div>
      <div v-if="step === 3">
        <h2>Choose Policy:</h2>
      </div>
      <div v-if="step === 4">
        <div
          v-if="getSessionData.htmlReport"
          v-html="getSessionData.htmlReport"
          class="wrapper-2 ma-2"
          style="max-height: 600px; overflow: auto; direction: ltr"
        ></div>
      </div>
      <NextBackButtons
        class="mt-4"
        :step="step"
        :backClicked="backClicked"
        :nextClicked="nextClicked"
        :isNextDisabled="isNextDisabled"
        :errorMessage="errorMessage"
      />
      <input
        @change="inputChanged"
        @click="fileInputClicked"
        type="file"
        multiple
        class="d-none"
        ref="fileInput"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Button from '@/components/BaseComponents/Button/Button.vue'
import NextBackButtons from '@/components/SelfFiltering/NextBackButtons/NextBackButtons.vue'
import SelectedFilesList from '@/components/CasualInterface/CasualUpload/SelectedFilesList.vue'
import { bytesToSize } from '@/utils'

export default {
  name: 'SelfFiltering',
  data() {
    return { step: 1 }
  },
  watch: {
    'getSessionData.totalSize': {
      handler: function (n) {
        console.log(n)
      },
    },
  },
  computed: {
    ...mapGetters(['isDarkMode', 'getSessionData']),
    isNextDisabled() {
      if (
        this.step === 2 &&
        (this.getSessionData?.filesData?.length != 1 ||
          this.getSessionData?.totalSize > 10 * 1024 * 1024)
      )
        return true
      return false
    },
    errorMessage() {
      if (this.step === 2 && this.getSessionData?.filesData?.length === 0)
        return 'No files detected'
      return ''
    },
    computedPolicies() {
      return [
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'pdf',
        'txt',
        'csv',
        'xml',
        'jpg',
        'jpeg',
        'bmp',
        'zip',
        'rar',
        '7z',
      ].join(', ')
    },
    computedSizeLimit() {
      return '10MB'
    },
  },
  filters: {
    bytesToSize,
  },
  components: {
    NextBackButtons,
    Button,
    SelectedFilesList,
  },
  methods: {
    ...mapActions(['fileSelectedForSelfFiltering', 'startSelfFiltering']),
    ...mapMutations(['resetState', 'SET_NOTIFICATION', 'clearFilesData']),
    backClicked() {
      if (this.step === 2) this.resetState()
      this.step--
    },
    nextClicked() {
      this.step++
      if (this.step === 2) {
        this.chooseFilesClicked()
      } else if (this.step === 4) {
        this.startSelfFiltering()
      }
    },
    chooseFilesClicked() {
      // this.clearFilesData()
      this.$refs.fileInput.click()
    },
    fileInputClicked(e) {
      e.target.value = ''
    },
    inputChanged(e) {
      console.log(e)
      this.clearFilesData()
      if (e.target.files.length != 1) {
        this.SET_NOTIFICATION({
          type: 'error',
          text: 'Select only one file.',
        })
      } else if (e.target.files[0].size > 10 * 1024 * 1024) {
        this.SET_NOTIFICATION({
          type: 'error',
          text: 'File size should be up to 10MB.',
        })
      } else {
        this.$store.dispatch('fileSelectedForSelfFiltering', e)
      }
    },
  },
}
</script>

<style scoped>
.half-page-wrapper {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.step {
  color: white;
  display: flex;
  flex-direction: column;
  margin-top: 7%;
  margin-left: 5%;
  /* justify-content: center;
  align-items: center; */
  padding: 16px;
  border-radius: 10px;
  min-width: 550px;
  width: fit-content;
}

.page-wrapper {
background: linear-gradient(115deg, rgba(181,82,191,1) 0%, rgba(95,95,239,1) 50%);
  width: 100%;
  height: 100%;
  display: flex;
  /* justify-content: center;
  align-items: center; */
  max-height: calc(100% - 50px);
}

.files-list-wrapper {
  max-width: 90%;
  min-width: 400px;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 600;
}

.welcome-content {
  font-size: 17px;
  margin-top: 12%;
  margin-left: 33%;
  font-weight: 400;
}
</style>
